module.exports = __webpack_public_path__ + "img/elton_john_juillet2021.9875bc23.jpg";